import { IsNotEmpty } from 'class-validator-i18n';

import { AuthenticateByBaseRequestDTO } from './AuthenticateByBaseRequestDTO';

export class AuthenticateByEmailTanRequestDTO extends AuthenticateByBaseRequestDTO {
  @IsNotEmpty()
  tanCode: string;
}
